// extracted by mini-css-extract-plugin
module.exports = {"destinationBase":"styles_destinationBase__nwUpB","topDestinationBtn":"styles_topDestinationBtn__MpZ1y","iconImage":"styles_iconImage__5dt_S"};